import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
const CheckoutForm: React.FC = () => {
  const navigate = useNavigate();
  const {
    state,
    dispatch
  } = useCart();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    cardNumber: '',
    expiryDate: '',
    cvv: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically process the payment
    dispatch({
      type: 'CLEAR_CART'
    });
    navigate('/thank-you');
  };
  return <div className="max-w-2xl mx-auto px-4 py-8" data-id="element-278">
      <h1 className="font-display italic text-3xl font-bold mb-8" data-id="element-279">Checkout</h1>
      <div className="mb-8" data-id="element-280">
        <h2 className="font-display italic text-xl font-bold mb-4" data-id="element-281">
          Order Summary
        </h2>
        <div className="space-y-4" data-id="element-282">
          {state.items.map(item => <div key={item.id} className="flex justify-between items-center" data-id="element-283">
              <div data-id="element-284">
                <p className="font-bold" data-id="element-285">{item.name}</p>
                <p className="text-sm text-gray-400" data-id="element-286">
                  Quantity: {item.quantity}
                </p>
              </div>
              <p data-id="element-287">${(item.price * item.quantity).toFixed(2)}</p>
            </div>)}
          <div className="border-t border-red-600/20 pt-4" data-id="element-288">
            <div className="flex justify-between font-bold" data-id="element-289">
              <span data-id="element-290">Total</span>
              <span data-id="element-291">${state.total.toFixed(2)}</span>
            </div>
          </div>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-292">
        <div className="grid grid-cols-2 gap-4" data-id="element-293">
          <input type="text" placeholder="First Name" required className="bg-black/50 border border-red-600/20 rounded-full px-4 py-2" data-id="element-294" />
          <input type="text" placeholder="Last Name" required className="bg-black/50 border border-red-600/20 rounded-full px-4 py-2" data-id="element-295" />
        </div>
        <input type="email" placeholder="Email" required className="w-full bg-black/50 border border-red-600/20 rounded-full px-4 py-2" data-id="element-296" />
        <input type="text" placeholder="Address" required className="w-full bg-black/50 border border-red-600/20 rounded-full px-4 py-2" data-id="element-297" />
        <div className="grid grid-cols-3 gap-4" data-id="element-298">
          <input type="text" placeholder="City" required className="bg-black/50 border border-red-600/20 rounded-full px-4 py-2" data-id="element-299" />
          <input type="text" placeholder="State" required className="bg-black/50 border border-red-600/20 rounded-full px-4 py-2" data-id="element-300" />
          <input type="text" placeholder="ZIP Code" required className="bg-black/50 border border-red-600/20 rounded-full px-4 py-2" data-id="element-301" />
        </div>
        <div className="border-t border-red-600/20 pt-6" data-id="element-302">
          <h2 className="font-display italic text-xl font-bold mb-4" data-id="element-303">
            Payment Information
          </h2>
          <div className="space-y-4" data-id="element-304">
            <input type="text" placeholder="Card Number" required className="w-full bg-black/50 border border-red-600/20 rounded-full px-4 py-2" data-id="element-305" />
            <div className="grid grid-cols-2 gap-4" data-id="element-306">
              <input type="text" placeholder="MM/YY" required className="bg-black/50 border border-red-600/20 rounded-full px-4 py-2" data-id="element-307" />
              <input type="text" placeholder="CVV" required className="bg-black/50 border border-red-600/20 rounded-full px-4 py-2" data-id="element-308" />
            </div>
          </div>
        </div>
        <button type="submit" className="w-full font-display italic bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded-full transition duration-300" data-id="element-309">
          Place Order
        </button>
      </form>
    </div>;
};
export const CheckoutPage = () => {
  return <Layout data-id="element-310">
      <div className="pt-32 bg-pattern-dark min-h-screen" data-id="element-311">
        <CheckoutForm data-id="element-312" />
      </div>
    </Layout>;
};